


































import { Component, Vue, Prop } from "vue-property-decorator";
import { getModule } from "vuex-module-decorators";
import { StoreReports } from "../store";
import { LivingAppsReportRecord, LivingAppsReportControl } from "../types";
import ReportDetailData from "../components/ReportDetailData.vue";
import ReportDetailForm from "../components/ReportDetailForm.vue";
import LoginForm from "../components/LoginForm.vue";
import { AlertController } from "@ionic/vue/dist/types/controllers";
import { OverlayController, AlertOptions } from "@ionic/core";
import { EventBus } from "@/main";

@Component({
  components: {
    ReportDetailData,
    ReportDetailForm
  }
})
export default class ReportDetail extends Vue {
  public storeReports = StoreReports;
  public report?: LivingAppsReportRecord;
  public controls?: LivingAppsReportControl | null;
  public edit: boolean = false;
  // public formIsDirty: boolean = false;

  public get filterReports() {
    for (const report of this.storeReports.getRecords) {
      if (report.id === this.$route.params.id) {
        this.report = report;
      }
    }
    return this.report;
  }

  public handleControls() {
    this.controls = this.storeReports.getControls;
  }

  public handleClick(route: string) {
    this.$router.push(route);
  }

  public editReport() {
    this.edit = true;
  }

  public formFinish() {
    const refForm: any = this.$refs.reportFormComp;
    if (refForm.isDirty) {
      EventBus.$emit("dirtyForm", this, refForm);
    } else {
      this.edit = false;
    }
  }

  public formCancel() {
    const refForm: any = this.$refs.reportFormComp;
    this.edit = false;
    refForm.isDirty = false;
  }

  public formSaved() {
    const refForm: any = this.$refs.reportFormComp;
    this.edit = false;
    refForm.isDirty = false;
  }

  protected mounted() {
    this.handleControls();
  }
}
